"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.regexp.split");

var _slicedToArray2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/slicedToArray"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

var _elementUi = require("element-ui");

var _store = _interopRequireDefault(require("@/store"));

var _auth = require("@/utils/auth");

var _router = _interopRequireDefault(require("@/router"));

var _lang = _interopRequireDefault(require("@/lang"));

(0, _axiosRetry.default)(_axios.default, {
  retries: 3,
  retryDelay: function retryDelay(retryCount) {
    console.log("retry attempt: ".concat(retryCount));
    return retryCount * 2000;
  },
  retryCondition: function retryCondition(error) {
    var serverError = error.response.status >= 500;
    var networkError = error.request.status >= 500;
    return serverError || networkError;
  }
}); // axios.defaults.timeout = 5000

_axios.default.defaults.baseURL = process.env.VUE_APP_BASE_API;
_axios.default.defaults.headers.post["Content-Type"] = "application/json";
_axios.default.defaults.headers.get["Content-Type"] = "application/json";

var noPermissionWarning = function noPermissionWarning() {
  _elementUi.MessageBox.alert(_lang.default.t("common.noPermissionWarning"), _lang.default.t("common.systemWarning"), {
    confirmButtonText: _lang.default.t("common.goBack"),
    type: "error"
  }).then(function () {
    return _router.default.go(-1);
  }).catch(function () {
    return _router.default.go(-1);
  }); // whatever action, need to go back

};

var invalidTokenWarningFlag = false;

var invalidTokenWarning = function invalidTokenWarning() {
  var reLogin = function reLogin() {
    _store.default.dispatch("user/resetToken").then(function () {
      _router.default.push("/".concat(_store.default.getters.mode, "Login"));
    });
  };

  if (!invalidTokenWarningFlag) {
    // to prevent multiple warning boxes
    invalidTokenWarningFlag = true;

    _elementUi.MessageBox.alert(_lang.default.t("common.invalidTokenWarning"), _lang.default.t("common.systemWarning"), {
      confirmButtonText: _lang.default.t("common.login"),
      type: "error"
    }).then(function () {
      return reLogin();
    }).catch(function () {
      return reLogin();
    }); // whatever action => need to re-login

  }
};

_axios.default.interceptors.request.use(
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(config) {
    var tokenFingerprint, _tokenFingerprint$spl, _tokenFingerprint$spl2, token, fingerprint, ip, local;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_store.default.getters.token) {
              _context.next = 7;
              break;
            }

            _context.next = 3;
            return (0, _auth.getToken)();

          case 3:
            tokenFingerprint = _context.sent;
            _tokenFingerprint$spl = tokenFingerprint.split('@'), _tokenFingerprint$spl2 = (0, _slicedToArray2.default)(_tokenFingerprint$spl, 2), token = _tokenFingerprint$spl2[0], fingerprint = _tokenFingerprint$spl2[1]; // reset dialog flag + no need to check the fingerprint

            if (config.url.startsWith('/login')) {
              invalidTokenWarningFlag = false;
            } // if it is not login controller + check the fingerprint
            else if (_store.default.getters.fingerprint !== fingerprint) {
                token = null;
              }

            config.headers["X-Token"] = token;

          case 7:
            ip = localStorage.getItem("ip");
            local = localStorage.getItem("language");
            config.headers['ip'] = ip;
            config.headers['language'] = local;
            return _context.abrupt("return", config);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  console.error(error);
  return Promise.reject(error);
});

_axios.default.interceptors.response.use(function (rsp) {
  var result = rsp.code ? rsp : rsp.data; // no permission

  if (result.code === 500 && result.message === '401' || result.code === 401) {
    return noPermissionWarning();
  }

  if (result.code === 500 && result.message === '403' || result.code === 403) {
    invalidTokenWarning();
    return Promise.reject({
      message: _lang.default.t("common.invalidTokenWarning")
    });
  }

  if (rsp.status === 200) {
    if (rsp.config.responseType === "blob" || result.code === 200) {
      return Promise.resolve(result);
    }
  }

  if (result.code === 200) {
    return Promise.resolve(result);
  }

  if (result.code === 500 && !result.msg) {
    // special for login
    return Promise.reject(result);
  }

  return Promise.resolve(result);
}, function (error) {
  // Handling CORS server have problem - return HTTP 401
  if (error.response) {
    return Promise.reject(error.response.data);
  } else {
    (0, _elementUi.Message)({
      message: _lang.default.t("message.errorNetwork"),
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject({
      message: _lang.default.t("message.errorNetwork")
    });
  }
});

var httpUtils = {
  $http: _axios.default,
  getByBlob: function getByBlob(controller, action, params, fileName) {
    //this.initParams(params);
    var url = this._path(controller, action); //url += "?" + this._queryString(params);


    (0, _axios.default)({
      method: "post",
      url: url,
      responseType: "blob",
      data: params
    }).then(function (response) {
      var blob = new Blob([response], {
        type: "application/ms-excel"
      });

      if ("download" in document.createElement("a")) {
        // 非IE下载
        var elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象

        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    }).catch(function (error) {
      _elementUi.MessageBox.alert(error.message, {
        type: 'error'
      });
    }); //return this.$get(url, config);
  },
  getByBlobForTxt: function getByBlobForTxt(controller, action, params, fileName) {
    //this.initParams(params);
    var url = this._path(controller, action); //url += "?" + this._queryString(params);


    (0, _axios.default)({
      method: "post",
      url: url,
      responseType: "blob",
      data: params
    }).then(function (response) {
      var blob = new Blob([response], {
        type: "text/txt,charset=UTF-8"
      });

      if ("download" in document.createElement("a")) {
        // 非IE下载
        var elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象

        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    }).catch(function (error) {
      _elementUi.MessageBox.alert(error.message, {
        type: 'error'
      });
    }); //return this.$get(url, config);
  },
  get: function get(controller, action, params, config) {
    var url = this._path(controller, action);

    url += "?" + this._queryString(params);
    return this.$get(url, config);
  },
  post: function post(controller, action, params, data, config) {
    var url = this._path(controller, action);

    url += "?" + this._queryString(params);
    return this.$post(url, data, config);
  },
  $get: function $get(url, config) {
    return this.$http.get(url, config);
  },
  $post: function $post(url, data, config) {
    return this.$http.post(url, data, config);
  },
  _path: function _path() {
    var url = "";

    for (var _len = arguments.length, pathArray = new Array(_len), _key = 0; _key < _len; _key++) {
      pathArray[_key] = arguments[_key];
    }

    pathArray.forEach(function (path) {
      if (path && path.length >= 1) {
        if (url === "/") {
          url += path;
        } else {
          url += "/" + path;
        }
      }
    });
    return url;
  },
  _queryString: function _queryString(obj) {
    var queryString = "";

    if (obj) {
      for (var key in obj) {
        if (Object.prototype.toString.call(obj[key]) === "[object Array]") {
          obj[key].forEach(function (item) {
            queryString += "&" + key + "=" + item;
          });
        } else {
          queryString += "&" + key + "=" + obj[key];
        }
      }

      if (queryString.length >= 1) {
        queryString = queryString.substr(1);
      }
    }

    return queryString;
  },
  initParams: function initParams(obj) {
    if (obj) {
      for (var key in obj) {
        if (!obj[key]) {
          delete obj[key];
        }
      }
    }

    return obj;
  }
};
var _default = httpUtils;
exports.default = _default;